import { render, staticRenderFns } from "./SttrPL_List.vue?vue&type=template&id=395fbe0a"
import script from "./SttrPL_List.vue?vue&type=script&lang=js"
export * from "./SttrPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports